import { useState , useEffect } from 'react'

import Layout from '../../components/layout/layout'
import { menuItem } from '../../utils/helper'

import GenericTreeList from '../../components/tree-list/tree-list'

import "./index.css"

const dummayData = [
    {
        id:1,
        Name:"General",
        Abbreviation:"",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:2,
        Name:"Mixed Model Repeated Measure",
        Abbreviation:"MMRM",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:3,
        Name:"Descriptive Statistics",
        Abbreviation:"DSTAT",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:4,
        Name:"Analysis of Covariance",
        Abbreviation:"ANCOVA",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:5,
        Name:"Rank Analysis of Covariance",
        Abbreviation:"Rank ANCOVA",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:6,
        Name:"Endpoints",
        Abbreviation:"EPT",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:7,
        Name:"Statistical Methods",
        Abbreviation:"STAT",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:8,
        Name:"Adverse Events",
        Abbreviation:"AE",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
    {
        id:9,
        Name:"Laboratory Data",
        Abbreviation:"LB",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null,
        multiSel:null
    },
]

const childdata = [
      {
        id:21,
        Name:"XXX",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1,
        multiSel:true
    },
      {
        id:22,
        Name:"XXX",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1,
        multiSel:true
    },
      {
        id:33,
        Name:"XXX",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1,
        multiSel:true
    },
      {
        id:44,
        Name:"XXX",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1,
        multiSel:true
    },
      {
        id:55,
        Name:"XXX",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1,
        multiSel:true
    },
]

const attachChildrenToAllParents = (parents, childTemplate) => {
  let newId = 100; // start new ids from here

  const allChildren = parents.flatMap(parent => {
    return childTemplate.map(child => ({
      ...child,
      id: newId++,                 // unique id
      parentId: parent.id          // attach to current parent
    }));
  });

  return [...parents, ...allChildren];
};

const SapMethod = () => {
    const [data,setData] = useState([])
    useEffect(()=>{
       setData( attachChildrenToAllParents( dummayData , childdata ) )
    },[])
  return (
    <Layout menuItem={menuItem} location={"/StatisticalAnalysisMethods"}>
            <GenericTreeList
                data={data}
                idField="id"
                parentIdField="parentId"
                subItemsField="items"
                columnType = "SapMethod"
             /> 
    </Layout>
  )
}

export default SapMethod